var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ve-player-box",
      style: {
        transform: `scale(${
          _vm.autoScale && !_vm.embedded ? _vm.screenScale : 1
        })`,
      },
    },
    [
      _vm.streamUrl
        ? _c(
            "div",
            { ref: "videoPlayerContainer", staticClass: "video-wrapper" },
            [
              _c(
                "div",
                { key: _vm.playerKey, staticClass: "video-player-key-wrapper" },
                [
                  _c("div", {
                    ref: "vePlayerContainer",
                    staticClass: "ve-player-container",
                    attrs: { id: _vm.containerId },
                  }),
                ]
              ),
              _vm.watermarkVisible &&
              _vm.streamWatermarkData &&
              _vm.streamWatermarkData.watermarkType === 1 &&
              _vm.streamWatermarkData.watermark
                ? _c(
                    "div",
                    {
                      staticClass: "video-layers",
                      class: `movement-${_vm.watermarkMovementType}`,
                      style: _vm.watermarkStyle,
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.streamWatermarkData.watermark) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.watermarkVisible &&
              _vm.streamWatermarkData &&
              _vm.streamWatermarkData.watermarkType === 2 &&
              _vm.streamWatermarkData.watermarkImageUrl
                ? _c("img", {
                    staticClass: "video-layers video-layers-image",
                    class: `movement-${_vm.watermarkMovementType}`,
                    style: _vm.watermarkStyle,
                    attrs: {
                      src: _vm.getWatermarkImageUrl(),
                      alt: "watermark",
                    },
                  })
                : _vm._e(),
              _vm.watermarkVisible &&
              _vm.streamWatermarkData &&
              _vm.streamWatermarkData.watermarkType === 5 &&
              _vm.streamWatermarkData.watermark
                ? _c(
                    "div",
                    {
                      staticClass: "video-layers",
                      class: `movement-${_vm.watermarkMovementType}`,
                      style: _vm.watermarkType5Style,
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.streamWatermarkData.watermark) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.watermarkVisible &&
              _vm.streamWatermarkData &&
              _vm.streamWatermarkData.watermarkType === 4 &&
              _vm.streamWatermarkData.watermark
                ? _c(
                    "div",
                    {
                      staticClass: "video-layers",
                      class: `movement-${_vm.watermarkMovementType}`,
                      style: _vm.watermarkStyle,
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.streamWatermarkData.watermark) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.streamWatermarkData &&
              (_vm.streamWatermarkData.watermarkType === 3 ||
                _vm.streamWatermarkData.watermarkType === 4) &&
              _vm.streamWatermarkData.watermark
                ? _c(
                    "div",
                    {
                      staticClass: "robust-watermark-overlay",
                      style: _vm.robustWatermarkOverlayStyle,
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.streamWatermarkData.watermark) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._t("overlay"),
            ],
            2
          )
        : _vm._t("no-stream", function () {
            return [
              _c(
                "div",
                { staticClass: "no-active-arena" },
                [
                  !_vm.streamError
                    ? _c("img", {
                        staticClass: "logo",
                        attrs: { src: require("@/assets/images/alert.webp") },
                      })
                    : _c("img", {
                        staticClass: "logo-out-of-balance",
                        attrs: {
                          src: require("@/assets/images/out-of-money.png"),
                        },
                      }),
                  _vm.streamError
                    ? [
                        _c("div", { staticClass: "text my-3" }, [
                          _vm._v(" " + _vm._s(_vm.$t("Stream locked")) + " "),
                        ]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.convertStreamErrorMessage(_vm.streamError)
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    : [
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("No fight at the moment")) + " "
                          ),
                        ]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("Please come back again")) + " "
                          ),
                        ]),
                      ],
                ],
                2
              ),
            ]
          }),
      !_vm.embedded
        ? _c(
            "div",
            {
              class: [
                "video-banner-wrapper",
                { "is-mobile": _vm.isMobile, reverse: _vm.isReverse },
              ],
            },
            [
              _c("div", { staticClass: "odds-wrapper" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("Banker")))]),
                _vm.autoScale && _vm.screenScale > 1
                  ? _c("span", { staticClass: "ml-16 odds" }, [
                      _vm._v(_vm._s(_vm.bankerOdds)),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "odds-wrapper" }, [
                _vm.autoScale && _vm.screenScale > 1
                  ? _c("span", { staticClass: "mr-16 odds" }, [
                      _vm._v(_vm._s(_vm.playerOdds)),
                    ])
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.$t("Player")))]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }